import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MenuItem } from '@mui/material/';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignOut } from '@fortawesome/free-solid-svg-icons';
export default function BotaoLogout({ handleLogout, sx = {} }) {
    return (_jsxs(MenuItem, Object.assign({ onClick: handleLogout, sx: sx }, { children: [_jsx(FontAwesomeIcon, { icon: faSignOut, style: { marginRight: 8 } }), "Logout"] })));
}
